/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function PenNib({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><g clipPath="url(#PenNib_svg__a)"><path fill="currentColor" d="M17.69 2.124 14.56 5.25l4.19 4.19 3.127-3.126a1.5 1.5 0 0 0 0-2.123l-2.068-2.067a1.5 1.5 0 0 0-2.123 0zM13.11 4.58l3.521-3.52a3 3 0 0 1 4.242 0l2.068 2.067a3 3 0 0 1 0 4.242l-3.52 3.52-1.758 6.455a3.76 3.76 0 0 1-2.541 2.606l-12.9 3.867a1.63 1.63 0 0 1-1.627-.412 1.64 1.64 0 0 1-.412-1.627l3.872-12.9a3.75 3.75 0 0 1 2.606-2.54zm.17 1.51L7.055 7.785A2.24 2.24 0 0 0 5.494 9.31L2.002 20.94l5.165-5.166a3 3 0 0 1-.417-1.524c0-1.655 1.345-3 3-3s3 1.345 3 3-1.345 3-3 3c-.558 0-1.078-.15-1.523-.417L3.06 21.999l11.63-3.488a2.25 2.25 0 0 0 1.523-1.56l1.697-6.226-4.636-4.636zm-3.53 6.66a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" /></g><defs><clipPath id="PenNib_svg__a"><path fill="#fff" d="M0 0h24v24H0z" /></clipPath></defs></svg>;
}
;